import { render } from "./TodoCardPagamento.vue?vue&type=template&id=5d685248"
import script from "./TodoCardPagamento.vue?vue&type=script&lang=js"
export * from "./TodoCardPagamento.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__